// extracted by mini-css-extract-plugin
module.exports = {"toastWrapper":"styles_toastWrapper__18Y7Z"};